import classNames from 'classnames';
import miniImage from '../../../../assets/images/fi-mini.png';
import { Links } from '../../../../lib/constants';
import { petPronouns } from '../../../../lib/petUtils';
import { gqlTypes } from '../../../../types/gqlTypes';
// the header and status card are the merged screen's, so the two confirmations read as one design
import successStyles from '../MergedSuccess/MergedSuccess.module.scss';
import styles from './RescueCollarClaimed.module.scss';

export interface RescueCollarClaimedProps {
  petName: string;
  chipId: string;
  gender?: gqlTypes.Gender | null;
  profilePhotoUrl?: string | null;
}

/**
 * The confirmation after an adopter says their rescue sent them home with its Fi Mini. It replaces
 * the GPS offer: they already have the tracker it sells. Claiming opened a pending adoption that the
 * adopter accepts in the Fi app, so that is where this sends them.
 */
export default function RescueCollarClaimed({ petName, chipId, gender, profilePhotoUrl }: RescueCollarClaimedProps) {
  const { object } = petPronouns(gender);

  return (
    <div className={successStyles.container}>
      <div className={successStyles.mainContent}>
        <div className={successStyles.badge}>Registered</div>
        <div className={successStyles.title}>{petName}'s chip is active.</div>

        <div className={classNames(successStyles.card, successStyles.statusCard)}>
          <div className={successStyles.avatar}>
            {profilePhotoUrl ? <img src={profilePhotoUrl} alt={petName} /> : <span>{petName.charAt(0)}</span>}
          </div>
          <div className={successStyles.statusInfo}>
            <div className={successStyles.statusPill}>Active</div>
            <div className={successStyles.statusName}>{petName}</div>
            <div className={successStyles.statusChip}>Chip {chipId}</div>
          </div>
        </div>

        <div className={classNames(successStyles.card, styles.collarCard)}>
          <img className={styles.collarImage} alt="Fi Mini" src={miniImage} />
          <div className={styles.collarText}>
            <div className={styles.collarTitle}>Finish setting up {petName}'s Fi Mini</div>
            <div className={styles.collarBody}>
              Open the Fi app and log in with this account to accept the Fi Mini your rescue sent home with {object}.
            </div>
          </div>
        </div>

        <div className={successStyles.ctaContainer}>
          <a className={successStyles.ctaPrimary} href={Links.app} target="_blank" rel="noopener noreferrer">
            Get the Fi app
          </a>
          <a className={successStyles.ctaGhost} href={Links.manageHome}>
            Go to my chips
          </a>
        </div>
      </div>
    </div>
  );
}
